import { Box, type Stack } from 'braid-design-system';
import type React from 'react';

import LayoutBox from 'src/components/LayoutBox/LayoutBox';

type BoxBackground = React.ComponentProps<typeof Box>['background'];
type StackChildren = React.ComponentProps<typeof Stack>['children'];

interface CellProps {
  background: BoxBackground;
  children: StackChildren;
}

const FeatureCell = ({ background, children }: CellProps) => (
  <Box background={background} padding="xsmall">
    <LayoutBox height={80} alignment="centre">
      {children}
    </LayoutBox>
  </Box>
);

export default FeatureCell;
